import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import Loading from "@/components/home/Loading";
import ResponseData from "@/types/ResponseData";
import Alert from "@/components/scan/parts/Alert.vue";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";
import KDPMasterMaintenanceDataService from "@/services/KDPMasterMaintenanceDataService";
import IssueSalesNoteDataService from "@/services/KDPIssueSalesNoteDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const menuCD = ref("");
const prodType = ref("P")

// 検索テキストボックス
const txtDistCd = ref("");
const searchedDistCd = ref("");
const specialChar = /[!@#$%^&'*+=;()_\-`~,.?":[\]{}|<>]/;
const onlyLetter = /^[A-Za-z]{6}$/;
const showDetailFlg = ref(false);
const noDataFlag = ref(" ");

// SMC確認者と承認者
const smcConfirmerId = ref("");
const smcConfirmer = ref("");
const approverId = ref("");
const approver = ref("");

// 代理店確認者と承認者
const distributorConfirmer1Id = ref("");
const distributorConfirmer2Id = ref("");
const distributorConfirmer3Id = ref("");
const distributorConfirmer4Id = ref("");
const distributorConfirmer5Id = ref("");
const distributorConfirmer1 = ref("");
const distributorConfirmer2 = ref("");
const distributorConfirmer3 = ref("");
const distributorConfirmer4 = ref("");
const distributorConfirmer5 = ref("");
const distributorApproverId = ref("");
const distributorApprover = ref("");

// Clearボタン有無フラグ
const clear1DisableFlag = ref(true);
const clear2DisableFlag = ref(true);
const clear3DisableFlag = ref(true);
const clear4DisableFlag= ref(true);
const clear5DisableFlag = ref(true);

// Changeボタン有無フラグ
const change2DisableFlag = ref(true);
const change3DisableFlag = ref(true);
const change4DisableFlag = ref(true);
const change5DisableFlag = ref(true);
// 決定ボタン有無フラグ
const ketteiDisableFlag = ref(true);
const deleteDisableFlag = ref(true);

// model
const txtUserId = ref("");
const radioCheckUserId = ref("");
const radioCheckUserName = ref("");
const radioCheckStationCd = ref("");
const radioCheckCompany = ref("");
const checkUser = ref("");
const modalSubject = ref("");
const modalBody = reactive([]);
const isCheckedOK = ref(true);
const isChecked = ref("");
const checkdistributorCode = ref("");

onMounted(()=>{
    menuCD.value = store.getters.mainMenuCode;
});

// 検索イベント
const btnSearch = () => {
  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // 入力チェック
  if ((txtDistCd.value.length) == 0 || (txtDistCd.value.length) < 6 ) {
    alert(i18n.t("alt101"));
    txtDistCd.value="";
    (document.getElementById("txtDistCd") as HTMLInputElement).focus();
    return;
  } 
  if (specialChar.test(txtDistCd.value)) {
    alert(i18n.t("alt113"));
    txtDistCd.value="";
    (document.getElementById("txtDistCd") as HTMLInputElement).focus();
    return;
  } 
  if (onlyLetter.test(txtDistCd.value) ) {
    alert(i18n.t("alt114"));
    txtDistCd.value="";
    (document.getElementById("txtDistCd") as HTMLInputElement).focus();
    return;
  } 

  showDetailFlg.value = true;
  searchedDistCd.value = txtDistCd.value;
  deleteDisableFlag.value = true;
  clearData();
  
  // 代理店コードの確認
  checkDistributorCode();
}

// データクリア
const clearData = () => {
  noDataFlag.value ="";

  // SMCの情報クリア
  smcConfirmerId.value ="";
  approverId.value ="";
  smcConfirmer.value ="";
  approver.value ="";

  // 代理店情報クリア
  distributorConfirmer1Id.value ="";
  distributorConfirmer2Id.value ="";
  distributorConfirmer3Id.value ="";
  distributorConfirmer4Id.value ="";
  distributorConfirmer5Id.value ="";
  distributorApproverId.value ="";
  distributorConfirmer1.value ="";
  distributorConfirmer2.value ="";
  distributorConfirmer3.value ="";
  distributorConfirmer4.value ="";
  distributorConfirmer5.value ="";
  distributorApprover.value ="";
}

// 代理店コードの確認
const checkDistributorCode = () => {
  isLoading.value = true;

  const distCdType = {
    functionName : "checkDistrbutorCodeExist",
    txtDistCd : txtDistCd.value,
    prodType : prodType.value
  } 
  KDPMasterMaintenanceDataService.checkDistrbutorCodeExist(distCdType)
    .then((response) => {
      checkdistributorCode.value = response.data.distributor_code;
      if (checkdistributorCode.value == "") {
        noDataFlag.value = 'NoDataShow';
        isLoading.value = false;
      } else {
        // 確認者．承認者情報取得
        getConfirmerDetail();
      }
    })
    .catch((e: Error) => {
      isLoading.value = false;
      console.log(e);
      alertMessage.value = i18n.t("err080").replace("errorMessageValue", "エラーが発生しました。");
      alertState.value = "error";
    }); 
}

// 確認者．承認者情報取得
const getConfirmerDetail = () =>{ 
  const distCD = {
    txtDistCd : searchedDistCd.value,
    prodType : prodType.value,
    userId: store.getters.cognitoUserName
  }  
  KDPMasterMaintenanceDataService.getKDPConfirmerInfo(distCD)
    .then((response: ResponseData) => {
      noDataFlag.value = 'DataShow';
      if (response.data.message == 'success') {
        if (response.data.length !== 0) {
          const info = response.data.data;
          smcConfirmerId.value = info.smcConfirmer.smcConfirmerId_id || '';
          if(info.smcConfirmer.smcConfirmerId_id != null){
            smcConfirmer.value = ` ${info.smcConfirmer.givenName || ''}${info.smcConfirmer.familyName || ''} (${info.smcConfirmer.smcConfirmerId_id || ''})`;
          }

          approverId.value = info.approver.approverId_id || '';
          if(info.approver.approverId_id != null){
              approver.value = ` ${info.approver.givenName}${info.approver.familyName || ''}(${info.approver.approverId_id || ''})`;
          }

          distributorConfirmer1Id.value = info.distributorConfirmer1.distributorConfirmer1Id_id || '';
          if(info.distributorConfirmer1.distributorConfirmer1Id_id != null){
              distributorConfirmer1.value = ` ${info.distributorConfirmer1.givenName || ''}${info.distributorConfirmer1.familyName || ''} (${info.distributorConfirmer1.distributorConfirmer1Id_id || ''}) \n` +
                                                  `(${info.distributorConfirmer1.stationCode || ''}:${info.distributorConfirmer1.companyName || ''})`;
          }

          distributorConfirmer2Id.value = info.distributorConfirmer2.distributorConfirmer2Id_id || '';
          if(info.distributorConfirmer2.distributorConfirmer2Id_id != null){
              distributorConfirmer2.value = ` ${info.distributorConfirmer2.givenName || ''}${info.distributorConfirmer2.familyName || ''} (${info.distributorConfirmer2.distributorConfirmer2Id_id || ''}) \n` +
                                                  `(${info.distributorConfirmer2.stationCode || ''}:${info.distributorConfirmer2.companyName || ''})`;
          }

          distributorConfirmer3Id.value = info.distributorConfirmer3.distributorConfirmer3Id_id || '';
          if(info.distributorConfirmer3.distributorConfirmer3Id_id != null){
              distributorConfirmer3.value = ` ${info.distributorConfirmer3.givenName || ''}${info.distributorConfirmer3.familyName || ''} (${info.distributorConfirmer3.distributorConfirmer3Id_id || ''}) \n` +
                                                  `(${info.distributorConfirmer3.stationCode || ''}:${info.distributorConfirmer3.companyName || ''})`;
          }

          distributorConfirmer4Id.value = info.distributorConfirmer4.distributorConfirmer4Id_id || '';
          if(info.distributorConfirmer4.distributorConfirmer4Id_id != null){
              distributorConfirmer4.value = ` ${info.distributorConfirmer4.givenName || ''}${info.distributorConfirmer4.familyName || ''} (${info.distributorConfirmer4.distributorConfirmer4Id_id || ''}) \n` +
                                                  `(${info.distributorConfirmer4.stationCode || ''}:${info.distributorConfirmer4.companyName || ''})`;
          }

          distributorConfirmer5Id.value = info.distributorConfirmer5.distributorConfirmer5Id_id || '';
          if(info.distributorConfirmer5.distributorConfirmer5Id_id != null){
              distributorConfirmer5.value = ` ${info.distributorConfirmer5.givenName || ''}${info.distributorConfirmer5.familyName || ''} (${info.distributorConfirmer5.distributorConfirmer5Id_id || ''}) \n` +
                                                  `(${info.distributorConfirmer5.stationCode || ''}:${info.distributorConfirmer5.companyName || ''})`;
          }

          distributorApproverId.value = info.distributorApprover.distributorApproverId_id || '';
          if(info.distributorApprover.distributorApproverId_id != null){
              distributorApprover.value = ` ${info.distributorApprover.givenName || ''}${info.distributorApprover.familyName || ''} (${info.distributorApprover.distributorApproverId_id || ''}) \n` +
                                                  `(${info.distributorApprover.stationCode || ''}:${info.distributorApprover.companyName || ''})`;
          }

          deleteDisableFlag.value = false;
        }
      } else if(response.data.message == 'success_without_data') {
        deleteDisableFlag.value = true;
      }
      checkBtnClear();
      checkBtnKettei();
      isLoading.value = false;     
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err080").replace("errorMessageValue", "エラーが発生しました。");
      alertState.value = "error";
      isLoading.value = false;
    });       
}

// Clearボタン有無チェック
const checkBtnClear =() =>{
  if (distributorConfirmer1Id.value.length != 0) {
    clear1DisableFlag.value = false;
    change2DisableFlag.value = false;
  } else {
    clear1DisableFlag.value = true;
    change2DisableFlag.value = true;
    change3DisableFlag.value = true;
    change4DisableFlag.value = true;
    change5DisableFlag.value = true;
  } 
  if (distributorConfirmer2Id.value.length != 0) {
    clear1DisableFlag.value = true;
    clear2DisableFlag.value = false;
    change3DisableFlag.value = false;
  } else {
    clear2DisableFlag.value = true;
    change3DisableFlag.value = true;
    change4DisableFlag.value = true;
    change5DisableFlag.value = true;
  }
  if (distributorConfirmer3Id.value.length != 0) {
    clear1DisableFlag.value = true;
    clear2DisableFlag.value = true;
    clear3DisableFlag.value = false;
    change4DisableFlag.value = false;
  } else {
    clear3DisableFlag.value = true;
    change4DisableFlag.value = true;
    change5DisableFlag.value = true;
  }
  if (distributorConfirmer4Id.value.length != 0) {
    clear1DisableFlag.value = true;
    clear2DisableFlag.value = true;
    clear3DisableFlag.value = true;
    clear4DisableFlag.value = false;
    change5DisableFlag.value = false;
  } else {
    clear4DisableFlag.value = true;
    change5DisableFlag.value = true;
  }
  if (distributorConfirmer5Id.value.length != 0) {
    clear1DisableFlag.value = true;
    clear2DisableFlag.value = true;
    clear3DisableFlag.value = true;
    clear4DisableFlag.value = true;
    clear5DisableFlag.value = false;
  } else {
    clear5DisableFlag.value = true;
  }
}

// 決定ボタン有無チェック
const checkBtnKettei =() =>{
  if (approverId.value.length != 0 && distributorApproverId.value.length != 0 ) {
    ketteiDisableFlag.value = false;
  } else {
    ketteiDisableFlag.value = true;
  }
}

// クリアボタンイベント
const btnClear = (txtID : string) =>{
  if (txtID == "APPROVER") {
    approverId.value ="";
    approver.value ="";
  } else if (txtID == "CONFIRMER") {
    smcConfirmerId.value = "";
    smcConfirmer.value = "";
  } else if (txtID !="APPROVER" && txtID !="CONFIRMER") {
    let distributorConfirmerId = {
      CONFIRMER1:distributorConfirmer1Id,
      CONFIRMER2:distributorConfirmer2Id,
      CONFIRMER3:distributorConfirmer3Id,
      CONFIRMER4:distributorConfirmer4Id,
      CONFIRMER5:distributorConfirmer5Id,
      DISTRIBUTER:distributorApproverId
    }
    for (let key in distributorConfirmerId){
      if (key == txtID){
          (distributorConfirmerId as any)[key].value ="";
      }
    }
    let distributorConfirmer = {
      CONFIRMER1:distributorConfirmer1,
      CONFIRMER2:distributorConfirmer2,
      CONFIRMER3:distributorConfirmer3,
      CONFIRMER4:distributorConfirmer4,
      CONFIRMER5:distributorConfirmer5,
      DISTRIBUTER:distributorApprover
    }
    for (let key in distributorConfirmer){
      if (key == txtID){
        (distributorConfirmer as any)[key].value ="";
      }
    }
  }
  checkBtnKettei();
  checkBtnClear();
}

// 削除ボタンイベント
const btnDelete = () => {
  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  if (confirm(i18n.t("cnf017"))) {
    isLoading.value = true;
    const param = {
      txtDistCd : searchedDistCd.value,
      prodType : prodType.value,
      userId: store.getters.cognitoUserName
    } 
    KDPMasterMaintenanceDataService.deleteConfirmerInfo(param)
      .then((response: ResponseData) => {
        if (response.data.message == 'Delete successfull') {
          showDetailFlg.value = false;
          txtDistCd.value="";
          searchedDistCd.value = "";
          
          // 正常メッセージ表示
          alertMessage.value = i18n.t("suc044");
          alertState.value = "success";

          (document.getElementById("txtDistCd") as HTMLInputElement).focus();
        } else if (response.data.message == 'No data') {
          alert(i18n.t("alt115"));
          (document.getElementById("txtDistCd") as HTMLInputElement).focus();
        } 
        isLoading.value = false;
      })
      .catch((e: Error) => {
        isLoading.value = false;
        console.log(e);
        // エラーメッセージ表示
        alertMessage.value = i18n.t("err080").replace("errorMessageValue", "エラーが発生しました。");
        alertState.value = "error";
      });   
  } else {
    deleteDisableFlag.value = false;
  }
}

// 決定ボタンイベント
const btnConfirm = () => {
  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  
  const dupliConfirmer = reactive([]);
  let k = 0;
  if (distributorConfirmer1Id.value !== "" && distributorConfirmer1Id.value === distributorApproverId.value) {
    showMessage("confirmer1");
    return;
  } else if (distributorConfirmer2Id.value !== "" && distributorConfirmer2Id.value === distributorApproverId.value) {
      showMessage("confirmer2");
      return;
  } else if (distributorConfirmer3Id.value !== "" && distributorConfirmer3Id.value === distributorApproverId.value) {
      showMessage("confirmer3");
      return;
  } else if (distributorConfirmer4Id.value != "" && distributorConfirmer4Id.value === distributorApproverId.value) {
      showMessage("confirmer4");
      return;
  } else if (distributorConfirmer5Id.value !== "" && distributorConfirmer5Id.value == distributorApproverId.value) {
      showMessage("confirmer5");
      return;
  } else if (distributorConfirmer1Id.value !== "" || distributorConfirmer2Id.value !== "" ||
  distributorConfirmer3Id.value !== "" || distributorConfirmer4Id.value !== "" ||
  distributorConfirmer5Id.value !== "" ) {
    let distributorConfirmer = {
      1:distributorConfirmer1Id,
      2:distributorConfirmer2Id,
      3:distributorConfirmer3Id,
      4:distributorConfirmer4Id,
      5:distributorConfirmer5Id
    }
    // 重複チェック
    for (let i=1;i<5;i++){
      for (let j=i+1;j<6;j++){
        if ((distributorConfirmer as any)[i].value !="" && (distributorConfirmer as any)[j].value !=""){
          if ((distributorConfirmer as any)[i].value == (distributorConfirmer as any)[j].value){
            if (dupliConfirmer.length==0){
              dupliConfirmer[k]="confirmer"+i;
              dupliConfirmer[k+1]="confirmer"+j;
              k +=2;
            }
            if (!dupliConfirmer.includes(`confirmer${i}`)){
              dupliConfirmer[k]="confirmer"+i;
              k +=1;
            }
            if (!dupliConfirmer.includes(`confirmer${j}`)){
              dupliConfirmer[k]="confirmer"+j;
              k +=1;
            }
          }
        }
      }
    }
    dupliConfirmer.sort();
    let strmsg = "Overlapping ";
    if (dupliConfirmer.length != 0){
      if (dupliConfirmer.length >2 ){
        for (let I=0;I<dupliConfirmer.length;I++) {
          if((dupliConfirmer.length-I) != 1) {
            if ((dupliConfirmer.length-I) != 2){
              strmsg = strmsg + dupliConfirmer[I] + ", ";
            } else {
              strmsg = strmsg + dupliConfirmer[I] + " and ";
            }
          } else {
            strmsg = strmsg + dupliConfirmer[I] ;
          }
        }
      } else if (dupliConfirmer.length ==2) {
        strmsg = strmsg + dupliConfirmer[0] + " and" + dupliConfirmer[1];
      }
      alert(i18n.t("alt109").replace("message", strmsg));
      return;
    } 
  }

  // 決定処理の確認
  if(confirm(i18n.t("cnf018"))){
    isKetteiDistCD(searchedDistCd.value);
  } else{
    checkBtnKettei();
  }
} 

const showMessage =(message : any) => {
  alert(i18n.t("alt108").replace("message", message));
}

// 検定処理
const isKetteiDistCD = (txtID :string) => {
  isLoading.value = true;
  const distCD = {
    txtDistCd : txtID,
    prodType : prodType.value,
    drafterId : store.getters.cognitoUserName,
    smcConfirmerId : smcConfirmerId.value,
    approverId : approverId.value,
    distributorConfirmer1Id  : distributorConfirmer1Id.value,
    distributorConfirmer2Id  : distributorConfirmer2Id.value,
    distributorConfirmer3Id  : distributorConfirmer3Id.value,
    distributorConfirmer4Id  : distributorConfirmer4Id.value,
    distributorConfirmer5Id  : distributorConfirmer5Id.value,
    distributorApproverId : distributorApproverId.value
  } 
  KDPMasterMaintenanceDataService.addorUpdateConfirmerInfo(distCD)
    .then(() => {
      alertMessage.value = i18n.t("suc045");
      alertState.value = "success";
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err080").replace("errorMessageValue", "エラーが発生しました。");
      alertState.value = "error";
      isLoading.value = false;
    });
}

onUpdated(function () {
  try {
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var tableHeight = document.getElementById("tblbodydiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
        document.getElementById("tblbodydiv").style.borderBottom = "#ccc solid 0.5px";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
});

const chkCheckEvent = (info : any) => {
  radioCheckUserId.value = info.userId;
  radioCheckUserName.value = info.userName;
  radioCheckStationCd.value = info.stationCode_id;
  radioCheckCompany.value = info.companyName;
  isCheckedOK.value = false;
};

// ユーザー名リストのモデル表示
const showModal = (param : any) => {
  modalBody.splice(0);
  isChecked.value = "";
  modalSubject.value = "Master Maintenance"
  txtUserId.value = "";
  checkUser.value = param;
  showUserDetail();
};

// ユーザー情報取得
const showUserDetail = ()=> {
  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  isLoading.value = true;
  if (checkUser.value != "APPROVER" && checkUser.value != "CONFIRMER"){
    const userList = {
      functionName : "getUserList",
      userId : txtUserId.value,
      menuCD : menuCD.value,
      parentDistributorCode : searchedDistCd.value
    }  

    /** ステータス表示 */
    IssueSalesNoteDataService.getKDPUserListLmabda(userList)
      .then((response: ResponseData) => {
        for (let info of response.data) {
          modalBody.push(info);
        }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err107");
      alertState.value = "error";
      isLoading.value = false;
    });
  } else {
    const userList = {
      txtUserId : txtUserId.value,
      userId : store.getters.cognitoUserName
    }  
    KDPMasterMaintenanceDataService.getKDPUserInfo(userList)
      .then((response: ResponseData) => {
        if (response.data.length !== 0) {
          for (let info of response.data) {
            modalBody.push(info);
          }
        }
        isLoading.value = false;
      })
      .catch((e: Error) => {
        alertMessage.value = i18n.t("err107");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
}

// ユーザー情報検索
const goDetailSearch = () => {
  modalBody.splice(0);
  showUserDetail();
}

// モデル閉じる
const goClose= () => {
  isCheckedOK.value=true;
}

// OKボタンイベント
const goOK = () => {
  if(isChecked.value != ""){
    showUserName();
  }
  radioCheckUserId.value = "";
  radioCheckUserName.value = "";
  radioCheckStationCd.value = "";
  radioCheckCompany.value = "";
  isCheckedOK.value = true;
  checkBtnClear();
  checkBtnKettei();
}

const showUserName = () => {
  if (checkUser.value == "APPROVER") {
    approver.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")";
    approverId.value = radioCheckUserId.value;
  } else if (checkUser.value == "CONFIRMER") {
    smcConfirmer.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")";
    smcConfirmerId.value = radioCheckUserId.value;
  } else if (checkUser.value == "CONFIRMER1") {
    distributorConfirmer1.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")" + "\n" +"("+ radioCheckStationCd.value + ":" + radioCheckCompany.value +")";
    distributorConfirmer1Id.value = radioCheckUserId.value; 
  } else if (checkUser.value == "CONFIRMER2") {
    distributorConfirmer2.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")" + "\n" +"("+ radioCheckStationCd.value + ":" + radioCheckCompany.value +")";
    distributorConfirmer2Id.value =  radioCheckUserId.value;
  } else if (checkUser.value == "CONFIRMER3") {
    distributorConfirmer3.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")" + "\n" +"("+ radioCheckStationCd.value + ":" + radioCheckCompany.value +")";
    distributorConfirmer3Id.value = radioCheckUserId.value;
  } else if (checkUser.value == "CONFIRMER4") { 
    distributorConfirmer4.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")" + "\n" +"("+ radioCheckStationCd.value + ":" + radioCheckCompany.value +")";
    distributorConfirmer4Id.value = radioCheckUserId.value;
  } else if (checkUser.value == "CONFIRMER5") {
    distributorConfirmer5.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")" + "\n" +"("+ radioCheckStationCd.value + ":" + radioCheckCompany.value +")";
    distributorConfirmer5Id.value = radioCheckUserId.value;
  } else if (checkUser.value == "DISTRIBUTER"){
    distributorApprover.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")" + "\n" +"("+ radioCheckStationCd.value + ":" + radioCheckCompany.value +")";
    distributorApproverId.value = radioCheckUserId.value;
  }
}

const __returned__ = { isLoading, alertMessage, alertState, i18n, menuCD, prodType, txtDistCd, searchedDistCd, specialChar, onlyLetter, showDetailFlg, noDataFlag, smcConfirmerId, smcConfirmer, approverId, approver, distributorConfirmer1Id, distributorConfirmer2Id, distributorConfirmer3Id, distributorConfirmer4Id, distributorConfirmer5Id, distributorConfirmer1, distributorConfirmer2, distributorConfirmer3, distributorConfirmer4, distributorConfirmer5, distributorApproverId, distributorApprover, clear1DisableFlag, clear2DisableFlag, clear3DisableFlag, clear4DisableFlag, clear5DisableFlag, change2DisableFlag, change3DisableFlag, change4DisableFlag, change5DisableFlag, ketteiDisableFlag, deleteDisableFlag, txtUserId, radioCheckUserId, radioCheckUserName, radioCheckStationCd, radioCheckCompany, checkUser, modalSubject, modalBody, isCheckedOK, isChecked, checkdistributorCode, btnSearch, clearData, checkDistributorCode, getConfirmerDetail, checkBtnClear, checkBtnKettei, btnClear, btnDelete, btnConfirm, showMessage, isKetteiDistCD, chkCheckEvent, showModal, showUserDetail, goDetailSearch, goClose, goOK, showUserName, Navigation, Loading, Alert, SalesNoteLinkNavigation, SalesNoteHeaderNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})